export interface IAgentEvent {
  eventType: AgentEventType;
  eventName?: string;
  userId?: number;
  endpointId?: number;
  domain?: string;
  source?: string;
  callerId?: string;
  callId?: string;
  transferFrom?: string;
  transferTo?: string;
  formVisitId?: number;
  orgId: number;
}

export enum AgentEventType {
  AGENT_SNOOPING_STARTED = 'AGENT_SNOOPING_STARTED',
  AGENT_CHAT_START = 'AGENT_CHAT_START',
  AGENT_CHAT_END = 'AGENT_CHAT_END',
  AGENT_ACCEPT_CHAT_TO_CALL_REQUEST = 'AGENT_ACCEPT_CHAT_TO_CALL_REQUEST',
  AGENT_DENY_CHAT_TO_CALL_REQUEST = 'AGENT_DENY_CHAT_TO_CALL_REQUEST'
}

export enum CallEventType {
  CALL_ANSWER_QUEUE = 'answered',
  CALL_ANSWER_SFU= 'answer',
  CALL_REJECT = 'rejected',
  CALL_UNANSWERED = 'timeout',
  ROOM_EXISTS ='roomExists',
  CALL_TRANSFER_AGENT ='transferAgent',
  CALL_TRANSFER_QUEUE ='transferQueue',
  BROADCAST_MESSAGE='broadcastMessage'
}
